export const nav = {
  home: "Welkom",
  howItWorks: "Hoe het werkt",
  discover: "Ontdekken",
  explore: "Verkennen",
  exploreDesc: "Ontdek leden en bestemmingen",
  destinations: "Bestemmingen",
  destinationsDesc: "Bekijk beschikbare bestemmingen",
  membersMap: "Ledenkaart",
  membersMapDesc: "Vind leden bij jou in de buurt",
  pricing: "Prijzen",
  dashboard: "Overzicht",
  dashboardDesc: "Beheer je advertenties en uitwisselingen",
  mySpace: "Mijn ruimte",
  myCalendar: "Mijn agenda",
  myCalendarDesc: "Beheer je agenda en uitwisselingen",
  incomingRequests: "Slimme matching",
  incomingRequestsDesc: "Ontvangen verzoeken en AI-suggesties",
  favorites: "Favorieten",
  favoritesDesc: "Jouw favoriete bestemmingen",
  messaging: "Berichten",
  messagingDesc: "Gesprekken en voorstellen",
  login: "Inloggen",
  signup: "Registreren",
  corporate: "Bedrijf",
  announcement:
    "DONKEY TRAVEL — De Europese huizenruilclub gereserveerd voor Airbnb-hosts met een beoordeling van 4,5 en hoger",
};
